<template>
  <v-card elevation="2">
    <div class="pa-4">
      <div class="d-flex align-center mx-n2" style="height: 28px">
        <v-spacer></v-spacer>
<!--         <v-btn
          class="mx-2"
          small
          color="transparent"
          elevation="2"
          @click="toggleEnableZoom"
          >{{ enableZoomButtonText }}</v-btn
        > -->
        <v-btn
          v-show="pickedPoem"
          class="mx-2"
          small
          color="transparent"
          elevation="2"
          @click="removeAddedPoem"
          >{{ $t("wordcloud.removeAddedMoodsMotifs") }}</v-btn
        >
        <v-btn
          v-show="showResetThemes"
          class="mx-2"
          small
          color="transparent"
          elevation="2"
          @click="resetToDefaultThemes"
          >{{ $t("wordcloud.resetThemes") }}</v-btn
        >
        <ResetButton
          :show="highlightFreezedByWordCloud"
          @reset="resetHighlight"
        />
        <InstructionIcon v-model="showInstruction" />
        <InstructionList
          :show="showInstruction"
          :list="$t('wordcloud.instructions')"
        />
      </div>
    </div>
    <div ref="wordcloudContainer">
      <WordCloudChart
        :words="allThemes"
        :color="color"
        :opacity="isThemeOpaque"
        :enableZoom="enableZoom"
        @click-word="onClickText"
        @right-click-word="onMouseEnterText"
      />
    </div>
    <Tooltip
      :word="activeWord"
      :show="showTooltip"
      :position="pointerPosition"
      :color="color"
      :sankey-themes-set="sankeyThemesSet"
      :poems="associatedPoems"
      :picked-poem="pickedPoem"
      @enter-tooltip="onMouseEnterText"
      @leave-tooltip="onMouseLeaveText"
      @enter-poem="onMouseEnterPoem"
      @leave-poem="onMouseLeavePoem"
      @click-poem="onTrClick"
    />
  </v-card>
</template>

<script>
import WordCloudChart from "./WordCloudChart.vue";
import Tooltip from "./Tooltip.vue";
import InstructionList from "@/components/InstructionList.vue";
import InstructionIcon from "@/components/InstructionIcon.vue";
import ResetButton from "@/components/ResetButton.vue";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { INTERACTION_CATEGORIES, INTERACTION_ACTIONS } from "@/store";
export default {
  components: {
    WordCloudChart,
    Tooltip,
    InstructionList,
    InstructionIcon,
    ResetButton
  },
  data: () => ({
    activeWord: null,
    showTooltip: false,
    pointerPosition: [0, 0],
    associatedPoems: [],
    showInstruction: false,
    timeout: null,
    enableZoom: false
  }),
  computed: {
    ...mapState([
      "highlightedThemes",
      "highlightedPoems",
      "highlightFreezed",
      "interactingCategory",
      "pickedThemes",
      "pickedPoem",
      "allThemes",
      "isShowingInstructionIcons"
    ]),
    ...mapGetters([
      "isHighlighting",
      "color",
      "sankeyThemesSet",
      "isThemeOpaque",
      "defaultPickedThemes"
    ]),
    enableZoomButtonText() {
      return this.enableZoom
        ? this.$t("wordcloud.disableZoom")
        : this.$t("wordcloud.enableZoom");
    },
    highlightFreezedByWordCloud() {
      return !!(
        this.highlightFreezed &&
        this.interactingCategory &&
        this.interactingCategory.startsWith("WORDCLOUD")
      );
    },
    showResetThemes() {
      return (
        JSON.stringify(this.defaultPickedThemes) !==
        JSON.stringify(this.pickedThemes)
      );
    }
  },
  methods: {
    ...mapMutations(["updateHighlightFreezed"]),
    ...mapActions([
      "updatePickedThemes",
      "updatePickedPoem",
      "resetHighlight",
      "updateHighlight"
    ]),
    toggleEnableZoom() {
      this.enableZoom = !this.enableZoom;
    },
    onMouseEnterText(d, event) {
      this.activeWord = d;
      this.associatedPoems = Array.from(new Set(d.value.items.values())).sort(
        (a, b) => a.year - b.year
      );
      if (event) {
        this.pointerPosition = [event.clientX, event.clientY];
      }
      this.showTooltip = true;
      if (this.highlightFreezed || !this.sankeyThemesSet.has(d.key)) return;
      this.updateHighlight({
        category: INTERACTION_CATEGORIES.SANKEY_THEME,
        value: d.key,
        action: INTERACTION_ACTIONS.HOVER_ADD
      });
    },
    onMouseLeaveText(d) {
      this.showTooltip = false;
      if (this.highlightFreezed || !this.sankeyThemesSet.has(d.key)) return;
      this.updateHighlight({
        category: INTERACTION_CATEGORIES.SANKEY_THEME,
        value: d.key,
        action: INTERACTION_ACTIONS.HOVER_REMOVE
      });
    },
    onMouseEnterPoem(d) {
      if (this.highlightFreezed) return;
      this.updateHighlight({
        category: INTERACTION_CATEGORIES.WORDCLOUD_POEM,
        value: d,
        action: INTERACTION_ACTIONS.HOVER_ADD
      });
    },
    onMouseLeavePoem(d) {
      if (this.highlightFreezed) return;
      this.updateHighlight({
        category: INTERACTION_CATEGORIES.WORDCLOUD_POEM,
        value: d,
        action: INTERACTION_ACTIONS.HOVER_REMOVE
      });
      this.onMouseEnterText(this.activeWord);
    },
    removeAddedPoem() {
      this.updatePickedPoem(null);
    },
    onTrClick(d) {
      let pickedPoem = d === this.pickedPoem ? null : d;
      this.updatePickedPoem(pickedPoem);
      if (pickedPoem) {
        this.updateHighlight({
          category: INTERACTION_CATEGORIES.WORDCLOUD_POEM,
          value: pickedPoem,
          action: INTERACTION_ACTIONS.CLICK_TOGGLE
        });
        this.updateHighlightFreezed(true);
      }
    },
    onClickText(d) {
      this.updatePickedThemes(d.key);
    },
    resetToDefaultThemes() {
      this.updatePickedThemes(null);
    }
  }
};
</script>
